import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'takeoff-group-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.css']
})
export class BreadcrumbComponent implements OnInit {
  // tslint:disable-next-line: no-input-rename
  @Input('bread-crumb-list') breadCrumbList = [];
  @Input() Url = '';
  constructor() {}

  ngOnInit() {}
}
